import type { InAppNotificationDto } from '@paladin-monorepo/common';
import { formatDate } from '@/utils/formatDate';

import { notificationTypeWeight, weightToColorMap } from './colors'

export interface NotificationItemProps {
  notification: InAppNotificationDto;
  onRead?: (notification: InAppNotificationDto) => void;
}

export const NotificationItem = ({
  notification,
  onRead,
}: NotificationItemProps) => {
  return (
    <div
      className="relative cursor-pointer rounded-md p-2 transition-colors hover:bg-muted"
      onClick={() => onRead?.(notification)}
    >
      <div className="text-sm font-medium">{notification.title}</div>
      <div className="text-sm font-medium text-muted-foreground">{notification.content}</div>
      <div className="text-xs font-medium text-muted-foreground">
        {formatDate(notification?.createdAt)}
      </div>
      {!notification?.readAt && (
        <span className={`absolute top-2 right-2 w-2 h-2 rounded-full ${weightToColorMap[notificationTypeWeight[notification.type]]}`} />
      )}
    </div>
  )
}
